module.exports = __webpack_public_path__ + "static/media/needs_icon_wh.53f5b170.svg";